import { initKakaoTvApi } from './kakaotv';

function subItemDisableHandler (editor) {
  return function () {
    editor.selection.selectorChanged('td', state => {
      this.disabled(state);
    });

    const selectionNode = editor.selection.getNode();

    if (!selectionNode) {
      return;
    }

    if (selectionNode.tagName.toLowerCase() === 'td') {
      this.disabled(true);
    }
  };
}

const plugin = function (editor) {
  const items = [
    { text: '사진', value: 'image', icon: 'image', classes: 'tistory-attach-item', cmd: 'KImageUpload' },
    { text: '파일', value: 'file', icon: 'file', classes: 'tistory-attach-item', cmd: 'KfileUpload', onpostrender: subItemDisableHandler(editor) },
    { text: '동영상', value: 'video', icon: 'video', classes: 'tistory-attach-item', cmd: 'OpenKakaoTVUploader', onpostrender: subItemDisableHandler(editor) },
    { text: '슬라이드쇼', value: 'image-slide', icon: 'imageSlide', classes: 'tistory-attach-item', cmd: 'KImageSlide', onpostrender: subItemDisableHandler(editor) },
  ];

  editor.addButton('tistory-attacher', {
    type: 'MenuButton',
    icon: 'image',
    tooltip: '첨부',
    fixedWidth: true,
    menu: {
      items,
    },
    onSelect (e) {
      if (e.control.settings.cmd) {
        editor.execCommand(e.control.settings.cmd);
      } else {
        alert('준비 중입니다.');
      }
    },
    onShowMenu () {
      this.menu.moveRel(this.getEl(), ['bc-tc', 'tc-bc']);
    },
  });

  initKakaoTvApi(editor);
};

export default plugin;
